export default __webpack_public_path__ + "static/media/G-1.c9398f64.svg";